import cx from "classnames";
import { Post } from "store/posts/postConstants";
import { validateImageUrl } from "utils/validateFileUpload";

interface ScheduledPostMediaDisplayProps {
  post: Post;
  mediaURL?: string;
  isCarousel?: boolean;
  images?: string[] | null;
  canEditPosts: boolean;
  openPostEditor: (instant?: boolean) => void;
}

const ScheduledPostMediaDisplay = ({
  post,
  mediaURL,
  isCarousel,
  images,
  canEditPosts,
  openPostEditor,
}: ScheduledPostMediaDisplayProps) => {
  const handleDoubleClick = () => {
    if (canEditPosts) {
      openPostEditor();
      console.warn(
        "Double click opened post editor. Design editor functionality needs review."
      );
    }
  };

  const handleClick = () => {
    if (canEditPosts) {
      openPostEditor();
    }
  };

  return (
    <div className="relative">
      {isCarousel && images && images.length > 1 && (
        <span className="single-scheduled-post__carousel-indicator absolute top-2 right-2 z-10 bg-black bg-opacity-50 text-white px-1.5 py-0.5 rounded text-xs">
          1/{images.length}
        </span>
      )}
      {mediaURL && validateImageUrl(mediaURL) ? (
        <img
          onDoubleClick={handleDoubleClick}
          className={cx("w-full h-auto object-cover max-h-96", {
            "cursor-pointer": canEditPosts,
          })}
          onClick={handleClick}
          src={mediaURL}
          alt={post.caption?.substring(0, 50) || "Scheduled post image"}
        />
      ) : mediaURL ? (
        <video className="w-full h-auto max-h-96" src={mediaURL} controls />
      ) : (
        <div className="w-full h-48 bg-gray-200 flex items-center justify-center text-gray-500">
          No media available
        </div>
      )}
    </div>
  );
};

export default ScheduledPostMediaDisplay;
